import { type AssignmentState } from "./state";

export const initialState: AssignmentState = {
  queue: [],
  ambassadors: [],
  loads: {},
  zones: [],
  isPending: false,
  isRejected: false,
  errorMessage: "",
  isAssigning: false,
  assignError: "",
  queryRows: null,
  isQuerying: false,
  detail: null,
  isDetailPending: false,
  isDetailRejected: false,
};
